// extracted by mini-css-extract-plugin
export default {"markdownPresenter":"IQrCbzTJ_B3HWGINQbOI-MarkdownPresenter-markdownPresenter","image":"dso89XOdbN0uW9PBfxgu-MarkdownPresenter-image"};